import { API_URL, FILE_URL } from '../../../../core/constants/endpoints';
import { isInstructor } from '../../../../core/selectors/classroom';
import { getMaterialPlacementLtiProviders } from '../../../../core/selectors/lti';
import { getFileScanStatus } from '../../../../core/selectors/fileScan';

const generateEditorConfig = ({
  state,
  itemType,
  itemId,
  enableAntivirusFileScan = false,
}) => {
  const spaceId = state.classRoom?.current;
  const accessToken = state.accessTokens[spaceId]?.token;
  const { institution } = state.institution?.general;
  const isEducator = isInstructor(state, state.user?.userId);

  const base = {
    itemId,
    accessToken,
    spaceId,
    institution,
    filesUrl: FILE_URL(),
    apiUrl: API_URL(),
    userId: state.user?.userId,
    isEducator,
    ltiProviders: getMaterialPlacementLtiProviders(state),
    itemType,
  };

  if (!enableAntivirusFileScan) {
    return base;
  }

  return {
    ...base,
    fileScanStatus: getFileScanStatus(state),
    enableFileScanStatus: true,
  };
};

export default generateEditorConfig;
